/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Hint_RkidInputs */

const cs_pm_hint_rkid = /** @type {(inputs: Pm_Hint_RkidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoda ID (rkid)`)
};

const en_pm_hint_rkid = /** @type {(inputs: Pm_Hint_RkidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID match (rkid)`)
};

/**
* | output |
* | --- |
* | "ID match (rkid)" |
*
* @param {Pm_Hint_RkidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_hint_rkid = /** @type {((inputs?: Pm_Hint_RkidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Hint_RkidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_hint_rkid(inputs)
	return cs_pm_hint_rkid(inputs)
});